import { NewsWidget, WidgetHost, WidgetContainerContext } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import SocialMediaNews from '@/modules/market-signals/components/social-media-news';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faRetweet } from '@fortawesome/free-solid-svg-icons';
import { MenuList } from '@/shared/components/export';
import { SocialMediaNewsPreferences } from '@/modules/market-signals/model/social-media';
//import { Permissions } from '@/core/permissions/model/permissions';

export class SocialMediaNewsWidget implements NewsWidget {
  containerClass(state: {} | undefined, preferences: {} | undefined): string {
    return 'h-100 p-2 border rounded-2';
  }

  get defaultRoute(): string {
    return '/';
  }

  get defaultTitle(): string {
    return 'AF Social Feed';
  }

  async hasPermission(permissions: string[]) {
    return permissions.includes('read:select:instantSocial');
  }

  shouldHideToUser?(permissions: string[]) {
    return !permissions.includes('read:select:instantSocial');
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return (
      <WidgetContainerContext.Consumer>
        {widgetContainer => {
          const preferences = widgetContainer.getPreferences<SocialMediaNewsPreferences>();
          const hideMediaOnlyPosts = preferences?.hideMediaOnlyPosts ?? false;
          const collapseMedia = preferences?.collapseMedia ?? false;

          return (
            <>
              <MenuList
                trigger={<FontAwesomeIcon icon={faFilter} />}
                toggleClassName={'btn btn-link p-2 text-primary-500'}
                toggleTitle={'Filter'}
                align={'right'}
                items={[
                  {
                    key: 'hide-media-only',
                    label: 'Hide media-only posts',
                    selected: hideMediaOnlyPosts,
                    onSelect: () =>
                      widgetContainer.updatePreferences<SocialMediaNewsPreferences>({
                        hideMediaOnlyPosts: !hideMediaOnlyPosts,
                      }),
                  },
                  {
                    key: 'collapse-media',
                    label: 'Collapse media',
                    selected: collapseMedia,
                    onSelect: () =>
                      widgetContainer.updatePreferences<SocialMediaNewsPreferences>({
                        collapseMedia: !collapseMedia,
                      }),
                  },
                ]}
              />
              {children}
            </>
          );
        }}
      </WidgetContainerContext.Consumer>
    );
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faRetweet} /> Social Feed{' '}
        <span className={'text-danger-emphasis'}>INTERNAL</span>
      </>
    );
  }

  get id(): string {
    return 'social-media-news';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: <SocialMediaNews />,
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return <>SocialMediaNews</>;
  }
}
